import type { ReactNode } from 'react';

interface AppLayoutProps {
  children: ReactNode;
}

/**
 * Sdílený layout komponent pro vstupní stránky.
 * Poskytuje konzistentní strukturu pro landing page a případně další veřejné stránky.
 */
export function AppLayout({ children }: AppLayoutProps) {
  return (
    <div className="phx-root bg-phx-bg text-phx-text min-h-screen">
      <main className="px-phx-6 py-phx-9 container mx-auto">{children}</main>
    </div>
  );
}

interface AppShellProps {
  children: ReactNode;
}

/**
 * Aplikační shell host pro pevný header, jednoduché hlavní menu a navigační viewport.
 * Pevná horní oblast (menu + breadcrumb) zůstává fixní nad navigačním obsahem.
 * Navigační viewport pod ní vyplní zbývající výšku.
 */
export function AppShell({ children }: AppShellProps) {
  return (
    <div className="phx-root bg-phx-bg text-phx-text flex h-screen flex-col overflow-hidden">
      {children}
    </div>
  );
}

/**
 * Pevná horní oblast shellu – kontejner pro menu a breadcrumb.
 * Obsah zůstává fixní i při scrollování navigačního viewportu.
 */
export function AppShellHeader({ children }: { children: ReactNode }) {
  return <header className="bg-phx-surface border-phx-border border-b">{children}</header>;
}

/**
 * Navigační viewport – vyplní zbývající prostor pod fixním headerem.
 */
export function AppShellViewport({ children }: { children: ReactNode }) {
  return <main className="bg-phx-bg relative flex-1 overflow-hidden">{children}</main>;
}
